import React, { useCallback, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import updateRelationTypeService from '../services/updateRelationTypeService';
import relationTypeService from '../services/relationTypeService';
import RelationTypeForm from './RelationTypeForm';
import { mapRelationTypeToForm } from '../helpers/mapRelationTypeToForm';
import { mapFormToRelationType } from '../helpers/mapFormToRelationType';

const EditRelationType = ({
  open,
  dispatchUpdateRelationTypePut,
  updateRelationTypeFetch,
  dispatchRelationTypeGet,
  relationTypeFetch,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateRelationTypePut(
        id,
        mapFormToRelationType(body),
        () => navigate(`/relation-types`),
        t
      ),
    [id, dispatchUpdateRelationTypePut, navigate, t]
  );

  useEffect(() => {
    if (open && id) {
      dispatchRelationTypeGet(id, () => navigate('/relation-types'), t);
    }
  }, [id, open, t, dispatchRelationTypeGet, navigate]);

  const defaultData = useMemo(() => mapRelationTypeToForm(relationTypeFetch.value), [
    relationTypeFetch.value,
  ]);

  if (!open) return null;

  return (
    <RelationTypeForm
      header={relationTypeFetch.value?.name}
      onSubmit={handleSubmit}
      submitProcessing={updateRelationTypeFetch.pending}
      returnRoute="/relation-types"
      cancelRoute="/relation-types"
      dataLoading={relationTypeFetch.pending}
      data={!relationTypeFetch.pending && defaultData}
      cancelButtonContent={t('close')}
      noSaveButton
      showRemoveButton
      editMode
    />
  );
};

EditRelationType.propTypes = {
  dispatchUpdateRelationTypePut: PropTypes.func.isRequired,
  updateRelationTypeFetch: PropTypes.object.isRequired,
  dispatchRelationTypeGet: PropTypes.func.isRequired,
  relationTypeFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditRelationType.defaultProps = { open: false };

export default compose(relationTypeService, updateRelationTypeService)(EditRelationType);
